import TeamRequestsFormatter from 'vacations-absences.module/features/teamRequests/teamRequests.formatters';
import { formatDateForView } from 'common/utils/dateUtils/date-utils';
import { isUndefinedOrNullOrEmpty } from 'common/utils/isUndefinedOrNullOrEmpty';

class TeamRequestModalApproveController {

  constructor($translate, $q) {
    'ngInject';
    this.translate = $translate;
    this.q = $q;
    this.formatter = new TeamRequestsFormatter();
  }

  $onInit() {
    this.translateKeys().then( ({daysLiteral, hoursLiteral}) => {
      this.daysLiteral = daysLiteral;
      this.hoursLiteral = hoursLiteral;
      this._getRequestInfo();
    });
  }

  isError() {
    return !isUndefinedOrNullOrEmpty(this.error);
  }

  isDelegated() {
    return this.delegation === true;
  }

  isSuccess() {
    return this.showSuccess === true;
  }

  translateKeys() {
    return this.q(resolve => {
      this.translate('GLOBALS.DAYS').then(daysLiteral => {
        this.translate('GLOBALS.HOURS').then(hoursLiteral => {
          resolve({ daysLiteral, hoursLiteral });
        });
      });
    });
  }

  _getRequestInfo() {
    this.message = this.formatter.formatRequestInfo(this.request, formatDateForView, this.daysLiteral, this.hoursLiteral);
  }
}

export default TeamRequestModalApproveController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestModalApprove/teamRequestModalApprove.controller.js